// removed by extract-text-webpack-plugin
module.exports = {"header":"c-MembershipHeader__header","title":"c-MembershipHeader__title","subTitle":"c-MembershipHeader__subTitle"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/MembershipHeader/MembershipHeader.scss
// module id = 517
// module chunks = 0